import React, { Component } from 'react';
import $ from 'jquery';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

class Privacy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isHovered: false,
    };
    this.handleHover = this.handleHover.bind(this);
  }
  handleHover() {
    // this.setState(prevState => ({
    //     isHovered: !prevState.isHovered
    // }));

    $("#clients div.client").hover(function () {
      $("#clients div.client").removeClass("pink_gradient")
      $(this).addClass("pink_gradient")
    }, function () {
      $("#clients div.client").removeClass("pink_gradient")
    })
  }
  render() {
    // const hoverClass = this.state.isHovered ? "client pink_gradient" : "client";
    // let sliderSettings = {
    //   dots: true,
    //   autoplay: true,
    //   infinite: true,
    //   speed: 500,
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   accessibility: false,
    //   className: 'benefits',
    //   prevArrow: <div><MdArrowBack /></div>,
    //   nextArrow: <div><MdArrowForward /></div>,
    // };

    return (
        <section id="privacy" className="section">
            <div className="container mt-xlg">
                <div className="row mb-xlg">
                    <div className="col-md-12 mb-xlg">
                        
                        <h2 className="panel_heading" style={{textAlign: "unset"}}>PhotoVision, Inc. – Privacy Policy</h2>
                        <p className="text_16 mt-sm">
                            Effective date: February 5, 2026
                        </p>
                        {/* <h2 className="panel_heading">Privacy Policy</h2>

                        <p className="text_18 text-muted dark mt-md">PhotoVision, Inc. is committed to protecting your privacy. The following privacy policy discloses what,
                            how, and why the information we require in doing a transaction with you through our website and
                            services. By using our website or our services, you agree to be bound by the terms of this policy.
                        </p> */}

                        <p className="text_22 mt-xxlg text-primary">
                            <strong className="semibold">Privacy Policy</strong>
                        </p>

                        <p className="text_16 mt-sm">
                            PhotoVision, Inc. (“PhotoVision,” “we,” “our,” or “us”) develops and manages the <strong className="semibold">
                            Group Travel Videos®</strong> app 
                            and other white label branded mobile applications (the “App”). This Privacy Policy describes 
                            how we collect, use, disclose, and safeguard information when using the App and our website.
                        </p>
                        <p className="text_16 mt-md">
                            By using Group Travel Videos, you agree to the practices described in this Privacy Policy.
                        </p>
                        <p className="text_16 mt-md">
                            PhotoVision, Inc. is committed to protecting your privacy. The following privacy policy discloses 
                            what, how, and why the information we require in doing a transaction with you through our website and services. 
                            By using our website or our services, you agree to be bound by the terms of this policy.
                        </p>
                        <p className="text_22 mt-xxlg text-primary">
                            <strong className="semibold">Personal Information</strong>
                        </p>

                        <p className="text_16 mt-sm">
                            Personal information is information that is unique to you (such as your name, address, e-mail address, telephone number). 
                            We do not collect or retain your credit card information. We only collect personal information from you to offer you our service. 
                            Because protecting your information is important to us, we do not sell any personal information to third parties. 
                            This information is only available to certain employees who have a need to see it in the execution of their job.
                        </p>

                        <p className="text_16 mt-md">
                            We may use independent contractors to provide services on our behalf. For example, we may use an e-commerce 
                            provider to handle your order or a payment processor to complete a transaction. Such third parties may have 
                            access to your personal information in the course of providing services on our behalf. Any personal information 
                            that we provide to such third parties is protected under a confidentiality or data processing agreement. 
                            Such third parties will take commercially reasonable measures to keep your personal information safe, 
                            private and secure. Independent contractors who service our technical hardware and software requirements 
                            have no possible access to this information unrelated to providing the contracted service.
                        </p>

                        <p className="text_22 mt-xxlg text-primary">
                            <strong className="semibold">Student Groups & Educational Use</strong>
                        </p>
                        <p className="text_16 mt-md">
                            Many of our customers use Group Travel Videos app, or our apps that are white labeled, for schoolaffiliated trips. 
                            We design our services to support strong student-privacy protections:
                        </p>
                        <ul className='privacy_ul mt-sm'>
                            <li>
                                <p>
                                    <strong className="privacy_li">No student accounts or PII required. </strong>
                                    Group Travel Videos does not require individual student accounts and does not ask students to provide 
                                    names, phone numbers, or email addresses. Access is provided via a shared group login managed by the 
                                    tour operator or group leader.
                                </p>
                            </li>
                            <li>
                                <p>
                                    <strong className="privacy_li">Minimal data model. </strong>
                                    We do not create, receive, or maintain student “educational records” on our own systems. 
                                    Any media (photos/videos) voluntarily uploaded by participants is used solely to create the private, 
                                    keepsake trip video and to facilitate trip communications within the group.

                                </p>
                            </li>
                            <li>
                                <p>
                                    <strong className="privacy_li">No commercial use or sale. </strong>
                                    We do not sell, share, or use participant content for advertising or other commercial purposes.
                                </p>
                            </li>
                            <li>
                                <p>
                                    <strong className="privacy_li">Ownership. </strong>
                                    All photos and videos uploaded by participants remain the property of the group or school (as applicable). 
                                    We act as a service provider to process and assemble that content for your group’s private use.
                                </p>
                            </li>
                            <li>
                                <p>
                                    <strong className="privacy_li">Retention & deletion. </strong>
                                    Because we do not require student PII to use the app, there is generally no personal student data to 
                                    delete. If any personal information is inadvertently provided to us, we will remove it upon a verified 
                                    request from the group organizer or school. Media content is retained only as long as reasonably 
                                    necessary to provide the service and to comply with legal obligations.
                                </p>
                            </li>
                            <li>
                                <p className="">
                                    <strong className="privacy_li">Agreements with school or district.  </strong>
                                    If a school or district enters into a written agreement with PhotoVision, that agreement will govern
                                    and, where applicable, will include student-privacy provisions required by the school or district.
                                </p>
                            </li>
                        </ul>
                        <p className="text_22 mt-xxlg text-primary">
                            <strong className="semibold">Information We Automatically Collect</strong>
                        </p>

                        <p className="text_16 mt-sm">
                            We automatically collect and store: the name of the domain and host from which you access the Internet; 
                            the Internet protocol (IP) address of the computer you are using; the browser software you use and your 
                            operating system; the date and time you access our sites; and the Internet address of the site from which 
                            you linked directly to our sites.

                        </p>

                        <p className="text_16 mt-md">
                            We use this information only as anonymous aggregate data to determine the number of visitors to different 
                            sections of our sites, to ensure the sites are working properly, and to help us make our sites more useful. 
                            We do not use it to track or record information about individuals. Generally, we delete this information 
                            after one year.

                        </p>
                        <p className="text_22 mt-xxlg text-primary">
                            <strong className="semibold">Geolocation Information</strong>
                        </p>
                        <p className="text_16 mt-md">
                            If you choose to enable location access, we may collect and temporarily store your <strong className="semibold">precise 
                            location information</strong> while our app is running in the foreground (open and on screen) or in 
                            the background (open but not on screen). Location data is used <strong className="semibold">solely to enhance safety, 
                            coordination, and peace of mind during your group trip.</strong>

                        </p>
                        <p className="text_16 mt-md">
                            Location sharing is <strong className="semibold">optional</strong>. You may use our services without enabling precise location access; however, 
                            doing so may limit certain location-based features or reduce accuracy during your trip. 

                        </p>
                        <p className="text_16 mt-md">
                            If precise location access is not enabled, only <strong className="semibold">approximate location information</strong> may be available. 

                        </p>
                        <p className="text_16 mt-md">
                            Location collection is <strong className="semibold">trip-specific and time-limited</strong>. It is active only during the scheduled dates of 
                            your group trip, beginning on the day of departure and automatically ending on the scheduled day of return. 
                            Location sharing is <strong className="semibold">disabled outside of this trip window.</strong> 

                        </p>
                        <p className="text_16 mt-md">
                            We <strong className="semibold">do not</strong> use location data for advertising, marketing, behavioral profiling, or analytics. 
                            We <strong className="semibold">do not sell</strong> location data, and we do <strong className="semibold">not share</strong> location data with third parties except as necessary 
                            to provide the core functionality of the service. 

                        </p>
                        <p className="text_16 mt-md">
                            Location data is retained <strong className="semibold">only for the duration necessary to support trip safety and coordination</strong> and is 
                            not retained after the trip concludes. You may disable location access at any time through your device settings. 

                        </p>

                        <p className="text_22 mt-xxlg text-primary">
                            <strong className="semibold">Information You Choose to Provide</strong>
                        </p>
                        <p className="text_16 mt-md">
                            Depending on how your travel program is configured, you may choose to provide: 

                        </p>
                        <ul className='privacy_ul mt-sm'>
                            <li>
                                <p>
                                    Photos and videos
                                </p>
                            </li>
                            <li>
                                <p>
                                    Messages sent within your private travel group
                                </p>
                            </li>
                            <li>
                                <p>
                                    Display name or nickname
                                </p>
                            </li>
                            <li>
                                <p>
                                    Documents or files shared within the group
                                </p>
                            </li>
                            
                        </ul>
                        <p className="text_16 mt-sm">
                            <strong className="semibold">Note:</strong> The Group Travel Videos app does <strong className="semibold">not 
                                require, or ask, for email addresses or phone numbers</strong> for participation
                        </p>
                        <p className="text_22 mt-xxlg text-primary">
                            <strong className="semibold">Cookies</strong>
                        </p>

                        <p className="text_16 mt-sm">
                            When you use our services as a registered user, we utilize cookies to store information about your visits 
                            to make your revisits more efficient for you and us. It is necessary to place the cookie on your computer’s 
                            hard drive in order for us to do this. This is a common practice used by most websites. We do not sell or 
                            give this information to any outside parties
                        </p>
                        <p className="text_16 mt-sm">
                            A “cookie” is a small text file that a Web site can place on your computer’s hard drive in order, 
                            for example, to collect information about your activities on the site or to make it 
                            possible for you to use an online “shopping cart” to keep track of items you wish to purchase. 
                            The cookie transmits this information back to the Web site’s computer which, generally speaking, 
                            is the only computer that can read it. Many consumers do not know that “cookies” are being placed on 
                            their computers when they visit Web sites. If you want to know when this happens, or to prevent it 
                            from happening, you can set your browser to warn you when a Web site attempts to place a “cookie” on 
                            your computer.
                        </p>

                        <p className="text_22 mt-xxlg text-primary">
                            <strong className="semibold">Security</strong>
                        </p>

                        <p className="text_16 mt-sm">
                            Protecting your information is very important to us, and we use commercially reasonable measures to 
                            provide secure transmission and storage of your information. These measures include encryption in transit, 
                            role-based access controls, and limiting access to personal information to authorized personnel with a business 
                            need. You should be aware that there is a level of risk involved in transmitting information over the Internet. 
                            As a result, we cannot ensure or warrant the security of the information that is transmitted over the 
                            Internet, and you do so at your own risk.
                        </p>

                        <p className="text_22 mt-xxlg text-primary">
                            <strong className="semibold">Device & App Usage Data</strong>
                        </p>

                        <p className="text_16 mt-md">
                            We may collect limited technical information, such as: 
                        </p>
                        <ul className='privacy_ul mt-sm'>
                            <li>
                                <p>
                                    Device type and operating system
                                </p>
                            </li>
                            <li>
                                <p>
                                    App version
                                </p>
                            </li>
                            <li>
                                <p>
                                    Crash reports and performance diagnostics
                                </p>
                            </li>
                        </ul>
                        <p className="text_16 mt-md">
                            This information is used solely to maintain, secure, and improve the App. 
                        </p>

                        <p className="text_22 mt-xxlg text-primary">
                            <strong className="semibold">How We Use Information</strong>
                        </p>

                        <p className="text_16 mt-md">
                            We use collected information to: 
                        </p>
                        <ul className='privacy_ul mt-sm'>
                            <li>
                                <p>
                                    Facilitate private group communication during travel programs
                                </p>
                            </li>
                            <li>
                                <p>
                                    Deliver shared trip photos, videos, and post-trip memory content
                                </p>
                            </li>
                            <li>
                                <p>
                                    Enable optional safety and coordination features (such as location sharing)
                                </p>
                            </li>
                            <li>
                                <p>
                                    Provide customer support
                                </p>
                            </li>
                            <li>
                                <p>
                                    Improve app performance and reliability
                                </p>
                            </li>
                        </ul>

                        <p className="text_22 mt-xxlg text-primary">
                            <strong className="semibold">How Information Is Shared</strong>
                        </p>

                        <p className="text_16 mt-md">
                            PhotoVision <strong className="semibold">does not sell user data.</strong> 
                        </p>
                        <p className="text_16 mt-md">
                            Information may be shared only:
                        </p>
                        <ul className='privacy_ul mt-sm'>
                            <li>
                                <p>
                                    Within the private travel group associated with your trip
                                </p>
                            </li>
                            <li>
                                <p>
                                    With trusted service providers (e.g., cloud hosting and infrastructure providers) 
                                    who process data on our behalf under strict confidentiality agreements
                                </p>
                            </li>
                            <li>
                                <p>
                                    When required to comply with legal obligations
                                </p>
                            </li>
                        </ul>

                        <p className="text_16 mt-md">
                            Location data is:
                        </p>
                        <ul className='privacy_ul mt-sm'>
                            <li>
                                <p>
                                    Shared <strong className="semibold">only with those traveling in the private group</strong>
                                </p>
                            </li>
                            <li>
                                <p>
                                    Accessible <strong className="semibold">only during the trip</strong>
                                </p>
                            </li>
                            <li>
                                <p>
                                    <strong className="semibold">Not retained</strong> after the trip concludes
                                </p>
                            </li>
                        </ul>

                        <p className="text_22 mt-xxlg text-primary">
                            <strong className="semibold">Data Retention</strong>
                        </p>

                        <ul className='privacy_ul mt-sm'>
                            <li>
                                <p>
                                    Photos, videos, messages, and documents are retained only as long as necessary to provide the service
                                </p>
                            </li>
                            <li>
                                <p>
                                    Location data is <strong className="semibold">temporary</strong> and 
                                    <strong className="semibold">not stored after the trip ends</strong>
                                </p>
                            </li>
                            <li>
                                <p>
                                    Users or program administrators may request deletion of data at any time
                                </p>
                            </li>
                        </ul>

                        <p className="text_22 mt-xxlg text-primary">
                            <strong className="semibold">Children’s Privacy</strong>
                        </p>

                        <p className="text_16 mt-sm">
                            Group Travel Videos is designed for <strong className="semibold">student and adult group travel programs.</strong>
                            The App is <strong className="semibold">not directed toward children under 13</strong>, and we do not collect personal information from children.

                        </p>
                        <p className="text_22 mt-xxlg text-primary">
                            <strong className="semibold">Your Choices and Controls</strong>
                        </p>

                        <p className="text_16 mt-sm">
                            You may request:
                        </p>

                        <ul className='privacy_ul mt-sm'>
                            <li>
                                <p>
                                    To enable or disable location access through your device settings or by contacting us if you wish
                                     to disable it for your trip.
                                </p>
                            </li>
                            <li>
                                <p>
                                    Messaging between students and the group leader is available, but students 
                                    cannot message each other. In the case of adult groups, users do have the ability 
                                    to message each other and the tour director. Messaging can be disabled entirely upon your request to us.
                                </p>
                            </li>
                            <li>
                                <p>
                                    Choose what content to upload or share
                                </p>
                            </li>
                            <li>
                                <p>
                                    Request access to or deletion of your data by contacting us
                                </p>
                            </li>
                        </ul>

                        <p className="text_22 mt-xxlg text-primary">
                            <strong className="semibold">Data Security</strong>
                        </p>

                        <p className="text_16 mt-sm">
                            We use industry-standard administrative, technical, and physical safeguards to protect information, 
                            including secure cloud storage and encryption where appropriate. While we take reasonable measures, 
                            no method of transmission or storage is completely secure.
                        </p>

                        <p className="text_22 mt-xxlg text-primary">
                            <strong className="semibold">Device Features & Monitoring</strong>
                        </p>

                        <p className="text_16 mt-sm">
                            Group Travel Videos includes optional features designed for trip coordination and 
                            safety (such as a traveler locator). Use of such features is controlled by the group organizer. 
                            We do not monitor keystrokes, browsing history, device files, or activate a device’s camera or microphone. 
                            Location-related features, if used, are limited to trip-coordination purposes and are not used for advertising.
                        </p>










                        <p className="text_22 mt-xxlg text-primary">
                            <strong className="semibold">Third Party Advertising</strong>
                        </p>

                        <p className="text_16 mt-sm">
                            PhotoVision does not work with third parties that provide paid advertisements to our site. 
                        </p>

                        <p className="text_22 mt-xxlg text-primary">
                            <strong className="semibold">External Links</strong>
                        </p>

                        <p className="text_16 mt-sm">
                            Our website may contain links to other sites for your convenience. In most cases, those sites 
                            are not under our control, and they have their own policies regarding privacy, which you should 
                            review before using them. We bear no responsibility for linked websites and provide these links 
                            solely for your convenience and information.

                        </p>

                        <p className="text_22 mt-xxlg text-primary">
                            <strong className="semibold">Use of Website by Children</strong>
                        </p>

                        <p className="text_16 mt-sm">
                            Our website is intended for the general audience and is not directed to children under the age of 13. 
                            Children under the age of 13 may not use our website. We respect the privacy of parents and children 
                            and are committed to complying with the Children’s Online Privacy Protection Act (COPPA). 
                            If a parent believes that his or her child has submitted personal information to us, he or 
                            she can contact us via e-mail or postal mail as listed below. We will promptly delete the 
                            information upon learning that it relates to a child under the age of 13.
                        </p>

                        <p className="text_22 mt-xxlg text-primary">
                            <strong className="semibold">Your Choices & Requests</strong>
                        </p>

                        <p className="text_16 mt-sm">
                            If, for any reason, you are concerned with the way that we may be using your personal information, 
                            you would like to request access, correction, or deletion of personal information, or you wish to 
                            file a complaint, you may contact us using the information below. Where we act as a service provider 
                            for a school or group, we will refer certain requests to the appropriate organizer or educational 
                            institution, as required.

                        </p>

                        <p className="text_22 mt-xxlg text-primary">
                            <strong className="semibold">Contacting PhotoVision, Inc.</strong>
                        </p>
                        
                        <p className="text_16 mt-sm">
                            Please contact us with any reason, concern, complaint, or general comment.
                        </p>
                        <p className="text_16 mt-sm">
                            PhotoVision, Inc. at 8300 Fairview Road Charlotte, NC 28227, <strong className="semibold">1-888-533-7637 x205. 
                            </strong>Our hours of operation are <strong className="semibold">9am to 5pm, Monday–Friday</strong>.
                        </p>

                        <p className="text_22 mt-xxlg text-primary">
                            <strong className="semibold">Changes to This Policy</strong>
                        </p>

                        <p className="text_16 mt-sm">
                            We may update this policy from time to time. Any changes will be posted on this page with an updated 
                            effective date February 5, 2026.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
  }
}

export default Privacy;